import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { ProductRepository } from '../../repositories/ProductRepository';

export class ProductLoadUseCase {
    private skudId: string;
    private productRepository: ProductRepository;

    constructor(skudId: string) {
        this.skudId = skudId;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        return this.productRepository.loadSkuById(this.skudId);
    };
}
